<template>
  <main class="app-container">
    <page-content page_key="recommend-leader"></page-content>

    <md-landscape v-model="showFullScreen" full-screen>
      <profile-form @onFormClose="handleFormClose"></profile-form>
    </md-landscape>

    <md-landscape v-model="showShareScreen" :mask-closable="true">
      <img src="../assets/images/share.png">
    </md-landscape>

    <div class="action-bar-placeholder"></div>
    <md-action-bar :actions="data"></md-action-bar>
  </main>
</template>

<script>

import { ActionBar, Landscape } from 'mand-mobile'

import PageContent from "../components/PageContent.vue";
import ProfileForm from "../components/ProfileForm.vue";
import WechatSdk from "../untils/wechat-sdk";


export default {
  name: "recommend-leader",
  components: {
      PageContent,ProfileForm,
      [ActionBar.name]: ActionBar,
      [Landscape.name]: Landscape,
  },
  data() {
      return {
          showFullScreen:false,
          showShareScreen:false,
          data: [
              {
                  text: '我要推荐',
                  onClick: this.handleClick,
              },
          ],
          model: {
              profile_updated: false,
          }
      }
  },
    created() {
        this.$toast.loading('加载中...');
        this.$http.get('users/me').then(({data}) => {
            this.model = data;
            this.setShareData();
        }).finally(() => this.$toast.hide());
    },
  methods: {
      handleClick() {
          if(this.model.profile_updated) {
              this.showShareScreen = true;
          } else {
              this.showFullScreen = true;
          }
      },
      handleFormClose() {
          this.model.profile_updated = true;
          this.showFullScreen = false;
          this.showShareScreen = true;
          this.setShareData();
      },
      setShareData() {
          if(!this.model.id || !this.model.profile_updated)
              return;

          const logo = "http://tofino.oss-cn-chengdu.aliyuncs.com/logo.png";
          const desc = `你的好友${this.model.nickname}推荐你成为出来玩leader`;
          const link = `${window.location.origin}/become-leader?referrer=${this.model.id}`;
          WechatSdk.updateAppMessageShareData({
              title: 'Wondergarten 出来玩', // 分享标题
              desc: desc, // 分享描述
              link: link,
              imgUrl: logo, // 分享图标
          });
          WechatSdk.updateTimelineShareData({
              title: desc, // 分享标题
              link: link,
              imgUrl: logo, // 分享图标
          });
      }
  },
};
</script>


<style lang="scss" scoped>


</style>
